// extracted by mini-css-extract-plugin
export var addButton = "_jw-0";
export var border = "_jw-8";
export var check = "_jw-h";
export var danger = "_jw-6";
export var dropdownContainer = "_jw-1";
export var editModalBody = "_jw-j";
export var footerContainer = "_jw-i";
export var fullWidth = "_jw-a";
export var hide = "_jw-9";
export var icon = "_jw-3";
export var input = "_jw-7";
export var inputFlex = "_jw-b";
export var inputWrapper = "_jw-c";
export var manualFocus = "_jw-5";
export var optionButton = "_jw-4";
export var pillWrapper = "_jw-e";
export var pointer = "_jw-2";
export var showOverflow = "_jw-f";
export var tagsFlex = "_jw-d";
export var xButton = "_jw-g";